import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Marquee } from '../components/Marquee';
import { About } from '../components/About';
import { EventsStrip } from '../components/EventsStrip';
import { Pillars } from '../components/Pillars';
import { MissionVision } from '../components/MissionVision';
import { Leadership } from '../components/Leadership';
import { News } from '../components/News';
import { InstagramFeed } from '../components/InstagramFeed';
import { GetInvolved } from '../components/GetInvolved';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="relative min-h-screen w-full overflow-x-hidden bg-sand font-sans text-ink antialiased" data-id="element-329" data-mp="29i7xjx1s1we0">
      <Navbar data-id="element-330" data-mp="2dfdrxr9ryos6" />
      <main className="w-full overflow-x-hidden" data-id="element-331" data-mp="3kvac6mkbgbvj">
        <Hero data-id="element-332" data-mp="3kuqw7be87xk5" />
        <Marquee data-id="element-333" data-mp="3kv0k8tfpnun7" />
        <About data-id="element-334" data-mp="3kxmx98ldf2ct" />
        <Leadership data-id="element-335" data-mp="3owlwcckf84wc" />
        <InstagramFeed data-id="element-336" data-mp="3ow403fxrdqof" />
        <EventsStrip data-id="element-337" data-mp="3ovatceysv16a" />
        <Pillars data-id="element-338" data-mp="3oyyjr58y77gs" />
        <MissionVision data-id="element-339" data-mp="30wrsmqffsfka" />
        <News data-id="element-340" data-mp="30x1jeg8b2qr1" />
        <GetInvolved data-id="element-341" data-mp="30vgnam6cezr2" />
      </main>
      <Footer data-id="element-342" data-mp="30uoz3wf2s4at" />
    </div>;
}